export default __webpack_public_path__ + "static/media/aboutus-6.75e2dfab.jpg";